
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.248 2.498a.75.75 0 01.75.75v16.753h16.753a.75.75 0 010 1.5H3.248a.75.75 0 01-.75-.75V3.248a.75.75 0 01.75-.75zM10.055 12a1.945 1.945 0 100-3.89 1.945 1.945 0 000 3.89zm10.697-6.32a2.431 2.431 0 11-4.863 0 2.431 2.431 0 014.863 0zM7.623 17.833a1.459 1.459 0 100-2.917 1.459 1.459 0 000 2.917zm10.21-3.403a1.459 1.459 0 11-2.917 0 1.459 1.459 0 012.917 0z"}})])
          )
        }
      }
    